import createIcon from '../../createIcon';

/**
 * @component @name AirplaneTicket
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuMTkgNEg0QzIuOSA0IDIuMDEgNC45IDIuMDEgNlYxMEMzLjExIDEwIDQgMTAuOSA0IDEyQzQgMTMuMSAzLjExIDE0IDIgMTRWMThDMiAxOS4xIDIuOSAyMCA0IDIwSDIwQzIxLjEgMjAgMjIgMTkuMSAyMiAxOFY2QzIyIDQuOSAyMS4xOSA0IDIwLjE5IDRaTTE3LjczIDEzLjNMOC44NyAxNS42Nkw3LjIxIDEyLjc4TDguMTQgMTIuNTNMOS40IDEzLjUyTDExLjc5IDEyLjg4TDkuMzkgOC43MkwxMC43OSA4LjM0TDE0LjggMTIuMDhMMTcuMjQgMTEuNDNDMTcuNzUgMTEuMjkgMTguMjggMTEuNiAxOC40MiAxMi4xMUMxOC41NSAxMi42MiAxOC4yNSAxMy4xNSAxNy43MyAxMy4zWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirplaneTicket = createIcon('AirplaneTicket', [
  [
    'path',
    {
      d: 'M20.19 4H4C2.9 4 2.01 4.9 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.19 4 20.19 4ZM17.73 13.3L8.87 15.66L7.21 12.78L8.14 12.53L9.4 13.52L11.79 12.88L9.39 8.72L10.79 8.34L14.8 12.08L17.24 11.43C17.75 11.29 18.28 11.6 18.42 12.11C18.55 12.62 18.25 13.15 17.73 13.3Z',
      key: '1e5pzt',
    },
  ],
]);

export default AirplaneTicket;
